export function getWindow(): Window | undefined {
    return typeof window as any === 'undefined' ? undefined : window;
}

